import React, { useMemo } from "react";
import { Modal, Form, Input, InputNumber, AutoComplete, Button } from "antd";

/**
 * 创建假人模态框
 */
const CreateBotModal = ({ visible, loading, bots = [], onCreate, onCancel }) => {
  const [form] = Form.useForm();

  // 从已有假人列表中提取唯一的 host:port 组合
  const hostOptions = useMemo(() => {
    const map = new Map();
    bots.forEach((bot) => {
      const key = bot.host;
      if (!map.has(key)) {
        map.set(key, {
          label: `${bot.host}:${bot.port}`,
          value: bot.host,
          port: bot.port,
        });
      }
    });
    return Array.from(map.values());
  }, [bots]);

  // 选中 AutoComplete 建议时自动填充端口
  const handleHostSelect = (value, option) => {
    if (option?.port) {
      form.setFieldsValue({ port: option.port });
    }
  };

  const handleFinish = (values) => {
    onCreate(values);
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="创建新假人"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      className="botcontrol-modal"
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="假人名称"
          name="name"
          rules={[{ required: true, message: "请输入假人名称" }]}
        >
          <Input
            placeholder="输入假人名称"
            className="form-input"
            disabled={loading}
          />
        </Form.Item>

        <Form.Item
          label="服务器地址"
          name="host"
          initialValue="mcctian.top"
          rules={[{ required: true, message: "请输入服务器地址" }]}
        >
          <AutoComplete
            options={hostOptions}
            onSelect={handleHostSelect}
            filterOption={(inputValue, option) =>
              option.value.toLowerCase().includes(inputValue.toLowerCase())
            }
            placeholder="输入服务器地址"
            className="form-input"
            disabled={loading}
            allowClear
          />
        </Form.Item>

        <Form.Item
          label="服务器端口"
          name="port"
          initialValue={25525}
          rules={[{ required: true, message: "请输入服务器端口" }]}
        >
          <InputNumber
            placeholder="输入服务器端口"
            className="form-input"
            min={1}
            max={65535}
            style={{ width: "100%" }}
            disabled={loading}
          />
        </Form.Item>

        <Form.Item label="登录密码（可选）" name="password">
          <Input.Password
            placeholder="输入密码，如果为空使用默认密码"
            className="form-input"
            disabled={loading}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ width: "100%" }}
          >
            创建假人
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateBotModal;
